import { SubscriptionShop } from "../../../../../shop/frontend/web/js/classes/SubscriptionShop.js";
import { utils } from "../utils";
import { MAX_INPUT, MIN_INPUT } from "../constants";

/**
 *  Класс описывающий реализацию абонемента
 * @extends SubscriptionShop
 */
export class Subscription extends SubscriptionShop {
	constructor() {
		super();
		this.$placeToSvg = null;
		this.$subscriptionMain = $("#js-subscription-main");
		this.subscriptionCount = this.$subscriptionMain.data("count");
		this.$checkboxes = $(".js-subscription-checkbox");
		this.allCheckboxesLength = this.$checkboxes.length;
		this.$checkboxAll = $("#js-checkbox-all");
		this.$checkedCount = $(".js-subscription-checked");
		this.$selectedCount = $(".js-subscription-selected");
		this.$items = $(".subscription__items");
		this.$input = $("#js-subscription-input");
		this.$minus = $("#js-subscription-minus");
		this.$plus = $("#js-subscription-plus");
		this.$buy = $("#js-subscription-buy");
		this.$changeCount = $("#js-subscription-count");
		this.$changeSeatsButton = $(".js-change-seats");
		this.$chooseSeatButton = $(".js-subscription-choose");
		this.$subscriptionLine = $(".subscription__line");
		this.$choosePlaces = null;
		this.zones = null;
		this.$ticketsItems = null;
		this.$sum = $("#js-subscription-score");
		this.$placesCancel = null;
		this.$placesOpen = $(".js-places-open");
		this.prices = [];
		this.$eventsBuy = $(".events__buy");
		this.$subscriptionBuy = $(".subscription__buy");
	}

	init() {
		this.getLanguages();
		this.setEventId();
		this.setUpListeners();
		this.updateCheckbox();
		this.updateInput();
		this.addActionToChooseSeat();
		this.getChange();
		this.updateLayoutOnMobile();
		this.toggleEvent();
		this.changeSeats();
		utils.toTop(this.$items);

		this.calculateTotalSumm();
	}

	setUpListeners() {
		if (this.isDesktop.matches) {
			$(document).on("mouseover", e => {
				const element = $(e.target);
				if (element.closest("g[mode]").length) {
					const activeSector = $(element).closest("g[mode]");
					const id = activeSector.attr("id");
					let name = activeSector.data("name") || activeSector.attr("sector_name");
					if (activeSector.attr("mode") === '1') {
						name = activeSector.find("text").text() || activeSector.data("name") || activeSector.attr("sector_name");
					}
					let price = activeSector.data("price") || activeSector.attr("price");
					const count = activeSector.attr("all");
					const free = activeSector.attr("free");
					if (!name) {
						const ticketItem = $(`.tickets__item[data-place="${id}"]`);
						name = ticketItem.find(".js-ticket-place").text();
						price = ticketItem.find(".js-ticket-price").text();
					}

					this.addTooltip(activeSector, price, name, count, free);
				} else {
					if (this.$tooltip) {
						this.$tooltip.hide();
						this.$tooltip.css({ left: 0, top: 0 });
					}
				}
			});

			this.$eventsBuy.on("mouseout", e => {
				const element = $(e.currentTarget);
				element.blur();
			});

			this.$subscriptionBuy.on("mouseout", e => {
				const element = $(e.currentTarget);
				element.blur();
			});
		}
	}

	setEventId() {
		this.eventId = this.$subscriptionMain.data("event");
		if (!this.eventId) {
			this.eventId = $(".subscription_index").data("event");
		}
	}

	updateCheckbox() {
		this.$checkboxes.on("change", e => {
			const checkbox = $(e.target);
			const parent = checkbox.parents(".subscription__item");
			const checked = $(".js-subscription-checkbox:checked").length;
			this.$checkedCount.text(checked);
			if (checkbox.is(":checked")) {
				parent.find(".subscription__choose").removeClass("inactive");
			} else {
				parent.find(".subscription__choose").addClass("inactive");
				parent.find(".js-change-seats").remove();
				this.getCartCount(this.eventId).then(res => {
					this.updateOtherSubscriptionSeats(res);
					this.calculateTotalSumm();
				});
			}

			if (checked < this.allCheckboxesLength) {
				this.$checkboxAll.prop("checked", false);
			}

			if (checked === this.allCheckboxesLength) {
				this.$checkboxAll.prop("checked", true);
			}

			this.calculateTotalSumm();
		});

		this.$checkboxAll.on("change", () => {
			if (this.$checkboxAll.is(":checked")) {
				this.$checkboxes.prop("checked", true);
				this.$checkedCount.text(this.allCheckboxesLength);
				$.each(this.$checkboxes, (index, elem) => {
					const checkbox = $(elem);
					const parent = checkbox.parents(".subscription__item");
					let count = parent.find(".tickets__item").length;
					this.subEventId = parent.data("event");
					parent.find(".subscription__choose").removeClass("inactive");
					if (!count) {
						parent.find(".subscription__choose").show();
					}
				});
				if (this.eventId) {
					this.addAllEvents().then(() => {
						this.calculateTotalSumm();
					});
				}
			} else {
				this.$checkboxes.prop("checked", false);
				this.$checkedCount.text(0);
				$(".subscription__score-old-price").hide();
				$.each(this.$checkboxes, (index, elem) => {
					const checkbox = $(elem);
					const parent = checkbox.parents(".subscription__item");
					this.subEventId = parent.data("event");
					if (!checkbox.is(":checked")) {
						parent.find(".subscription__line").remove();
					}
					parent.find(".subscription__choose").show().addClass("inactive");
				});
				$(".js-subscription-selected").text(0);
				this.removeAllEvents().then(() => {
					this.getCartCount().then(() => {
						this.calculateTotalSumm();
					});
				});
			}
		});
	}

	updateInput() {
		this.$plus.on("click", () => {
			const value = Number(this.$input.val());

			this.$input.val(value + 1);
			if (this.$input.val() > MAX_INPUT || Number(this.$input.val()) === MAX_INPUT) {
				this.$input.val(MAX_INPUT);
				this.$plus.attr("disabled", true);
			}
			this.$minus.removeAttr("disabled");
		});

		this.$minus.on("click", () => {
			const value = Number(this.$input.val());

			this.$plus.removeAttr("disabled");
			this.$input.val(value - MIN_INPUT);
			if (this.$input.val() < MIN_INPUT || Number(this.$input.val()) === MIN_INPUT) {
				this.$input.val(MIN_INPUT);
				this.$minus.attr("disabled", true);
			}
		});

		this.$input.on("input", () => {
			const value = Number(this.$input.val());

			if (value > MIN_INPUT) {
				this.$minus.removeAttr("disabled");
			} else {
				this.$minus.attr("disabled", true);
			}
			if (value === MAX_INPUT || value > MAX_INPUT) {
				this.$input.val(MAX_INPUT);
				this.$plus.attr("disabled", true);
			} else {
				this.$plus.removeAttr("disabled");
			}

			if (value < MIN_INPUT) {
				this.$input.val(MIN_INPUT);
				this.$minus.attr("disabled", true);
			}
		});
	}

	getChange() {
		this.$changeCount.on("click", e => {
			const name = $(e.currentTarget).data("name");
			this.getSubscriptionChange(name).then(response => {
				this.$modalContent.html(response);
				this.$modal.addClass("modal_subscription");
				this.$modal.modal("show");
			});
		});
	}

	addActionToChooseSeat() {
		this.$chooseSeatButton.on("click", e => {
			this.getSvg(e.currentTarget);
		});
	}

	updateZones(res) {
		let arr = Object.values(res.zones);
		let com = [];
		for (let i = 0; i < arr.length; i++) {
			for (let j = 0; j < com.length; j++) {
				if (com[j] && arr[i]) {
					if (com[j].price === arr[i].price) {
						com[j].free += arr[i].free;
						arr.splice(i, 1);
					}
				}
			}

			if (!com[i] && arr[i]) {
				com.push(arr[i]);
			}
		}
		let obj = {};
		obj.zones = { ...com };
		return obj;
	}

	getSvg(element) {
		this.$modalContent.html("");
		const button = $(element);
		const item = button.parents(".subscription__item");
		this.subUnittId = item.data("unit");
		this.$placesInfoTop = $("<div class='places__info-top'></div>");
		const name = item.find(".teams").clone();
		const date = item.find(".time").clone();
		const place = item.find(".place").clone();
		this.subEventId = Number(item.data("event"));
		this.getCurrentSubscriptionCartCount(true).then(() => {
			this.getPlaces()
				.then(response => {
					this.$places = $(
						`<div class='places places_subscription' id="js-places"></div>`
					);
					this.$playInfo = $(` <div class="play-info">
									<div class="play-info__text">${this.getWord(
										"main",
										"The site is a testing platform: money will not be charged for the purchase of tickets"
									)}
									</div>
									<button type="button" class="play-info__close reset-btn" id="js-hide-play-info">
										<svg height="20" width="20">
											<use xlink:href="#close"></use>
										</svg>
									</button>
								</div>`);
					this.$chooseSector = $(
						`<div class='places__choose-sector'>${this.getWord(
							"main",
							"Select sector"
						)}</div>`
					);
					this.$choosePlaces = $(
						`<div class="places__choose">Выберите <span class="desktop">желаемые</span> места на схеме: <strong id="js-places-choose">0</strong>/${this.subscriptionCount}</div>`
					);
					this.$placesLegend = $(
						`<div class="places__legend">${this.getWord(
							"main",
							"Select price to see the available seats with selected price on the plan"
						)}</div>`
					);
					this.$back = $(
						`<button type="button" class="back back_primary">
							<svg class="icon icon_back back__icon" width="20" height="20">
								<use xlink:href="#back"></use>
							</svg>
							<span class="back__text">${this.getWord("main", "Back to sectors")}</span>
						</button>`
					);
					this.$placesInfo = $(`<div class="places__info">
					<div class="places__info-item places__info-item_work">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "your seats")}</div>
					</div>
					<div class="places__info-item places__info-item_disabled">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "not available")}</div>
					</div>
						<div class="places__info-item places__info-item_disabled places__info-item_sector">
						<div class="places__info-color"></div>
						<div class="places__info-text">${this.getWord("main", "sector is not available")}</div>
					</div>
				</div>`);
					this.$placesFixed = $(`<div class='places__fixed'></div>`);
					this.$placesSvgWrap = $(`<div class='places__svg-wrap'></div>`);
					this.$placesSvg = $(`<div class='places__svg loading'></div>`);
					const placesCenter = $(`<div class='places__center'></div>`);
					this.$bottom = $(`<div class='bottom bottom_subscription'></div>`);
					const bottomBuyInfo = $(`<div class='bottom__buy-info'></div>`);
					this.$placesSum = $(
						`<strong class='places__sum'><span class="js-sum"></span> ${this.getWord(
							"main",
							"$"
						)}</strong>`
					);
					this.$placesCancel = $(
						`<button class="btn btn_auto btn_link places__cancel" id="js-close-subscription-popup" type="button">${this.getWord(
							"main",
							"Cancel"
						)}</button>`
					);
					this.$placesBuy = $(
						`<a href="/subscription-cart/scope-add/${this.eventId}/${
							this.subEventId
						}" class='btn btn_primary btn_usual inactive js-hover-out'>${this.getWord(
							"main",
							"Continue"
						)}</a>`
					);
					$(this.$placesBuy).on("click", function () {
						//при нажатии продолжить сделать дизейбл кнопки
						$(this).addClass("inactive");
					});
					const tickets = $(`<div class='js-tickets tickets tickets_fixed'></div>`);
					this.$ticketsItems = $(`<div class='tickets__items js-tickets-items'></div>`);
					const placesControls = $(`<div class='places__controls'></div>`);
					this.$prices = $(`<div class='places__prices'></div>`);
					this.zones = response.area.zones;
					this.$planZoomIn = $(`<button class="places__control places__control_plus"
								id="js-plan-zoom-in" type="button" aria-label="zoom-in">
						</button>`);
					this.$planZoomReset = $(`<button class="places__control places__control_reset"
								id="js-plan-zoom-reset" type="button" aria-label="reset">
						</button>`);
					this.$planZoomOut = $(`<button class="places__control places__control_minus"
								id="js-plan-zoom-out" type="button" aria-label="zoom-out">
						</button>`);
					this.$placesPull = $(
						'<div class="order__pull"><button class="order__pull-button reset-btn" type="button">' +
							'<svg width="22" height="7" class="icon icon_pull"><use xlink:href="#pull"></use> </svg></button></div>'
					);
					this.$placesCost = $(
						'<div class="places__cost" id="js-places-cost"> <div class="places__row">' +
							'<div class="places__count js-places-open"><span class="js-count"></span>' +
							'<span class="js-places-description"><span class="places__count-word js-count-word"></span></span></div>'
					);
					this.$tooltip = $(`<div class="tooltip-info js-seat-info">
						<div class="tooltip-info__name"></div>
						<div>
							<span class="tooltip-info__available"></span>
							<span class="tooltip-info__count"></span>
						</div>
						<div class="tooltip-info__price"></div>
					</div>`);
					placesControls.append(this.$planZoomReset);
					placesControls.append(this.$planZoomIn);
					placesControls.append(this.$planZoomOut);
					this.$placesSvg.append(response.area.svg);
					this.$placesInfoTop.append(name);
					this.$placesInfoTop.append(date);
					this.$placesInfoTop.append(place);
					this.$places.append(this.$placesInfoTop);
					if (fakePayment) {
						this.$places.append(this.$playInfo);
					}
					placesCenter.append(placesControls);
					placesCenter.append(this.$back);
					this.addActionToBack();
					placesCenter.append(this.$choosePlaces);
					placesCenter.append(this.$chooseSector);
					this.$placesFixed.append(this.$placesLegend);
					this.$placesFixed.append(this.$prices);
					this.$placesFixed.append(this.$placesInfo);
					this.$placesFixed.append(this.$placesPull);
					this.$placesFixed.append(this.$placesCost);
					this.$placesSvgWrap.append(this.$placesSvg);
					placesCenter.append(this.$placesSvgWrap);
					placesCenter.append(this.$placesFixed);
					this.$places.append(placesCenter);
					tickets.append(this.$ticketsItems);
					if (this.isDesktop.matches) {
						this.$bottom.append(tickets);
					} else {
						this.$placesFixed.append(tickets);
					}
					bottomBuyInfo.append(this.$placesCancel);
					bottomBuyInfo.append(this.$placesSum);
					bottomBuyInfo.append(this.$placesBuy);
					this.$bottom.append(bottomBuyInfo);
					this.$places.append(this.$bottom);
					this.$modalContent.html(this.$places);
					this.$modal.append(this.$tooltip);
					this.$modal.addClass("modal_subscription modal_place");
					this.$modal.modal({
						show: true,
						backdrop: "static", //не закрывать модалку при нажатии на фон
					});
				})
				.then(() => {
					if (this.isDesktop.matches) {
						setTimeout(() => {
							const areaHeight = Math.round(
								this.$placesSvg[0].getBoundingClientRect().height
							);
							$(".places__center").css("min-height", `${areaHeight}px`);
						}, 200);
					}

					this.$placesPull.on("click", () => {
						$(".js-tickets").toggle();
						$(".places__svg").toggleClass("inactive");
						$(".places__prices").toggleClass("inactive");
						$("html").toggleClass("overflow-hidden");
					});

					this.getPrices(0, this.subEventId)
						.then(response => {
							this.$svg = $("#svg");

							if (!this.$svg.length > 0)
								console.log("Не удалось найти svg план мероприятия!");

							this.$placeToSvg = $(".places__svg");
							this.$elements = this.$svg.find("g[mode]");
							$.each(this.$elements, (index, elem) => {
								const element = $(elem);
								let mode = Number(element.attr("mode"));
								if (mode === 1) {
									this.isSectorPlan = true;
								}
							});
							if (this.isSectorPlan) {
								this.setTags();
								this.uniquePrices = {};
								this.zones.forEach(item => {
									this.uniquePrices[item.zone] = item.price;
								});
								this.getZones(this.subEventId).then(res => {
									this.setZones(this.updateZones(res));
									this.addActionToPricesLabelToSector();

									if (!this.isDesktop.matches) {
										$(".places__choose-sector").after($(".places__prices"));
									}
								});
								this.$placesLegend.hide();
								this.$placesInfo.addClass("places__info_sector");
								this.addActionToSector();
								this.$back.removeClass("active");
							} else {
								this.$elements.addClass("default");
								this.setColorToPlace(response);
								this.setPricesLabelToPlace(this.zones);
								this.addActionToPricesLabelToPlace();
								this.$choosePlaces.show();
								this.$chooseSector.hide();
							}

							this.setSvgPlan();
							this.addActionAfterClosePopup();
						})
						.then(() => {
							this.$placesSvg.removeClass("loading");
							if (this.arrayOfPlaces.length) {
								let hasPlaces = false;
								let countTickets = 0;
								const sum = this.$placesSum.find(".js-sum");
								$.each(this.arrayOfPlaces, (index, elem) => {
									if (Number(elem.event_id) === this.subEventId) {
										hasPlaces = true;
										countTickets++;
										const ticket = this.insertDataToTicket(elem, false);
										this.$ticketsItems.append(ticket);
										$("#js-places-choose").text(
											Number($("#js-places-choose").text()) + 1
										);
										$(`#${elem.sid}`)
											.addClass("in-cart")
											.data("available", "false");

										sum.text(Number(sum.text()) + elem.price);
									}
								});
								if (hasPlaces) {
									this.$bottom.addClass("active");
									this.$placesFixed.addClass("active");
									if (
										Number($("#js-places-choose").text()) ===
										this.subscriptionCount
									) {
										this.$placesBuy.removeClass("inactive");
										this.$elements.addClass("inactive");
									}
									$(".js-places-open").addClass("visible");
									$(".js-places-open .js-count").text(countTickets);
									$(".js-places-open .js-count-word").text(
										" " +
											utils.wordEnding(countTickets, [
												this.getWord("event", "ticket"),
												this.getWord("event", "tickets"),
												this.getWord("event", "tickets "),
											])
									);
								}
							}
							if (!this.isSectorPlan) {
								this.addActionToPlaces();
							}
							this.addActionToTicket();
						});
				});
		});
	}

	updateSeatCount(eventId) {}

	addActionToTicket() {
		$("#js-popup-modal .modal-body").on("click", ".tickets_fixed .js-tickets-remove", e => {
			const element = e.currentTarget;
			const parent = $(element).parents(".tickets__item");
			const sid = parent.data("place");
			this.setEventId();
			this.removeFromSubscriptionCart(sid);
			$(`#${sid}`).data("available", "true").removeClass("in-cart");
			parent.remove();
		});
	}

	updateLayoutOnMobile() {
		if (!this.isDesktop.matches) {
			$.each(this.$subscriptionLine, (index, element) => {
				const line = $(element);
				const parent = line.parents(".subscription__item");
				const info = parent.find(".subscription__info");
				const name = parent.find(".subscription__name");
				const price = parent.find(".subscription__price");
				info.after(line);
				name.before(price);
			});
		}
	}

	toggleEvent() {
		$.each(this.$checkboxes, (index, elem) => {
			const checkbox = $(elem);
			const parent = checkbox.parents(".subscription__item");

			checkbox.on("change", () => {
				this.subEventId = Number(parent.data("event"));
				if (checkbox.is(":checked")) {
					this.addSubscriptionEvent().then(() => {
						this.calculateTotalSumm();
					});
				} else {
					this.removeSubscriptionEvent().then(() => {
						const item = $(`.subscription__item[data-event="${this.subEventId}"]`);
						item.find(".tickets").remove();
						item.find(".js-subscription-choose").show();
						let selected = 0;
						$.each($(`.subscription__item`), (index, item) => {
							if ($(item).find(".tickets__item").length > 0) {
								selected++;
							}
						});
						this.$selectedCount.text(selected);
						const prices = $(".js-ticket-price");
						let sum = 0;
						$.each(prices, (index, element) => {
							const price = $(element);
							sum += Number(price.text());
						});
						this.getCartCount().then(res => {
							$.each(res, (i, it) => {
								$.each(it.carts, (index, item) => {
									const cart = $(`.tickets__item[data-uid="${item.uid}"]`);
									const price = cart.find(".js-ticket-price");
									price.data("price", item.price);
									price.data("default", item.default_price);
									price.text(item.default_price);
								});
							});

							this.calculateTotalSumm();
						});
					});
				}
			});
		});
	}

	changeSeats() {
		this.$changeSeatsButton.on("click", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".subscription__item");
			this.subEventId = parent.data("event");
			this.getChangeSeats().then(res => {
				if (res.result === true) {
					this.getSvg(e.currentTarget);
					this.$selectedCount.text(Number(this.$selectedCount.text()) - 1);
					//this.$buy.addClass("disabled");
					const prices = parent.find(".js-ticket-price");
					let disSum = 0;
					$.each(prices, (index, el) => {
						const price = Number($(el).text());
						disSum += price;
					});
					//this.$sum.text(Number(this.$sum.text()) - disSum);
					parent.find(".tickets").remove();
					element.remove();
					parent.find(".js-subscription-choose").show();
				} else {
					window.location.reload(); //прошло 30мин
				}
			});
		});
	}

	addActionAfterClosePopup() {
		this.$placesCancel.on("click", () => {
			$.each(this.$elements, (index, elem) => {
				const element = $(elem);
				if (element.hasClass("in-cart")) {
					const sid = element.attr("id");
					element.data("available", "true");
					this.removeFromSubscriptionCart(sid);
				}
			});
			$("#js-popup-modal .modal-body").off();
			$("#js-popup-modal.modal_subscription").modal("hide");
			this.calculateTotalSumm(); //обновить стоимость
		});
	}

	checkAllEvents() {
		if (!this.$checkboxAll.is(":checked")) {
			this.$checkboxAll.prop("checked", true);
			this.$checkboxes.prop("checked", true);
			this.$checkedCount.text(this.allCheckboxesLength);
			$.each(this.$checkboxes, (index, elem) => {
				const checkbox = $(elem);
				const parent = checkbox.parents(".subscription__item");
				this.subEventId = parent.data("event");
				parent.find(".subscription__choose").removeClass("inactive");
			});
		} else {
			if (this.eventId) {
				this.addAllEvents();
			}
		}
	}

	checkBuyButton() {
		if (
			this.$sum.text() == "" ||
			this.$sum.text() == 0 ||
			$(".js-subscription-selected").text() == 0 ||
			$(".js-subscription-checked").first().text() != $(".js-subscription-selected").text()
		) {
			this.$buy.addClass("disabled");
		}

		if (
			$(".js-subscription-selected").text() == $(".js-subscription-checked").first().text() &&
			$(".js-subscription-selected").text() != 0
		) {
			this.$buy.removeClass("disabled");
		}
	}
}
